import React from 'react';
import { Typography, TextField, TypographyVariant, SxProps } from '@mui/material';

interface TextInputBoxProps {
    labelSize?: TypographyVariant;
    label?: string;
    name?: string;
    value?: any;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    placeholder?: string;
    type?: string;
    sx?: SxProps;
    required?: boolean; // 新增 required 屬性
    disabled?: boolean;
    className?: string;
}

const TextInputBox: React.FC<TextInputBoxProps> = ({
    labelSize = 'h6',
    label,
    name,
    value,
    onChange,
    placeholder = '',
    type = 'text',
    sx = {},
    required = false,
    disabled = false,
    className = '',
}) => (
    <>
        <Typography variant={labelSize} align="left" gutterBottom>
            {label}
            {required && <span style={{ color: 'red' }}>*</span>} {/* 顯示必填標記 */}
        </Typography>
        <TextField
            variant="outlined"
            name={name}
            fullWidth
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            type={type}
            sx={{ mb: 2, ...sx }}
            size='small'
            disabled={disabled}
            className={className}
        />
    </>
);

export default TextInputBox;
